import { Navigate, useLocation } from 'react-router-dom';
import { isTokenValid } from '@lib/auth';
import useAuthStore from '@stores/authStore';

export default function ProtectedRoute({ children, requiredRole }) {
  const location = useLocation();
  const { token, isAuthenticated, hasRole } = useAuthStore();

  if (!isAuthenticated || !token || !isTokenValid(token)) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requiredRole && !hasRole(requiredRole)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
